import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'group relative',
    cursor: 'pointer-events-none fixed top-0 left-0 z-50 items-center justify-center',
    icon: 'h-9 w-9'
  },
  variants: {
    enabled: {
      true: {
        base: 'cursor-none **:cursor-none!'
      }
    },
    visible: {
      true: {
        cursor: 'flex'
      },
      false: {
        cursor: 'hidden'
      }
    }
  }
});
